import { render, staticRenderFns } from "./TableCellObject.vue?vue&type=template&id=0e88261d&scoped=true&"
import script from "./TableCellObject.vue?vue&type=script&lang=js&"
export * from "./TableCellObject.vue?vue&type=script&lang=js&"
import style0 from "./TableCellObject.vue?vue&type=style&index=0&id=0e88261d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e88261d",
  null
  
)

export default component.exports
import {QTooltip} from 'quasar'
component.options.components = Object.assign({QTooltip}, component.options.components || {})
